export const LIST_RELEASES = [
    { 
        versao: "2.2.1", 
        data: "23/09/2024", 
        listDescricoes: [
            "Histórico de produtos",
            "Mostrar ultimas atualizações feitas",
        ]
    },
    { 
        versao: "2.2.2", 
        data: "27/09/2024", 
        listDescricoes: [
            "Tratativa na flag de desconto de campanha",
            "Correção na validação de compra mínima",
        ]
    },
    { 
        versao: "2.2.3", 
        data: "09/10/2024", 
        listDescricoes: [
            "Separação do custo base",
            "Atualização do prazo entrega na integração com o totvs",
            "Correção da multiplicação por 100 na edição da cotação",
            "Validação de margem minima no carrinho para não travar"
        ]
    },
    { 
        versao: "2.2.4", 
        data: "10/10/2024", 
        listDescricoes: [
            "Correções no calculo do custo base",
        ]
    },
    { 
        versao: "2.2.5", 
        data: "16/10/2024", 
        listDescricoes: [
            "Automatização da natureza",
            "Exportação dos produtos de código fechado",
        ]
    },
    { 
        versao: "2.2.9", 
        data: "23/10/2024", 
        listDescricoes: [
            "Importação de produto código fechado",
            "Ajuste no calculo do icp quando o desconto for zero",
            "Correção no botão para aplicar a margem e prazo de entrega a todos os parametros",
        ]
    },
    { 
        versao: "2.3.1", 
        data: "24/10/2024", 
        listDescricoes: [
            "Ajustes na importação de produto código fechado",
        ]
    },
    { 
        versao: "2.3.2", 
        data: "25/10/2024", 
        listDescricoes: [
            "Ajustes no calculo base dos parametros",
        ]
    },
    { 
        versao: "2.3.3", 
        data: "28/10/2024", 
        listDescricoes: [
            "Correção na consulta de pedido para integração",
            "Correção no calculo do icp",
        ]
    },
    { 
        versao: "2.3.4", 
        data: "29/10/2024", 
        listDescricoes: [
            "Exportação dos produtos de código parametrizável",
            "Log do Status e Indisponibilidade do produto",
            "Tratativa campanha de crédito"
        ]
    },
    { 
        versao: "2.3.5", 
        data: "06/11/2024", 
        listDescricoes: [
            "Importação dos produtos de código parametrizável",
            "Considerar o desligamento manual da chave de campanha",
            "Acrescentado transportadora e cnpj do cliente na página do cliente",
            "Informação do estoque na consulta do produto",
            "Informativo de consulta de estoque no PDF da cotação",
        ]
    },
    { 
        versao: "2.3.6", 
        data: "06/11/2024", 
        listDescricoes: [
            "Correção da validação de compra mínima",
            "Correção do prazo de entrega para cotações de entrega turbo",
            "Correção do prazo de entrega dos itens com peça em estoque e o prazo é editado",
        ]
    },
    { 
        versao: "2.3.7", 
        data: "28/11/2024", 
        listDescricoes: [
            "Adicionado dados de contato no carrinho e edição da cotação",
            "Considerar prazo de entrega dos parametros quando maior que o prazo padrão",
            "Notificação de alteração de prazo de entrega",
        ]
    },
    { 
        versao: "2.3.8", 
        data: "28/11/2024", 
        listDescricoes: [
            "Adicionado endpoint para testes do Totvs",
            "Ajuste no envio de e-mail de atualização do prazo de entrega",
        ]
    },
    { 
        versao: "2.3.9", 
        data: "10/12/2024", 
        listDescricoes: [
            "Acrescentado informação do ST",
            "Validação de cadastro do código do produto duplicado",
        ]
    },
    { 
        versao: "2.4.0", 
        data: "13/12/2024", 
        listDescricoes: [
            "Acrescentado informação do ST do PDF",
            "Adicionado tratamento para consulta de saldo de campanha",
            "Adicionado email e telefone do vendedor no pdf da cotação",
        ]
    },
    { 
        versao: "2.4.1", 
        data: "08/01/2025", 
        listDescricoes: [
            "Correção importação",
        ]
    },
    { 
        versao: "2.4.2", 
        data: "15/01/2025", 
        listDescricoes: [
            "Correção na area minhas informações",
            "Acrescentado informação do tipo de pedido na página do cliente",
            "Correção na visualização das cotações feitas pelo admin",
            "Tratamento no aumento de qtde",
        ]
    },
    { 
        versao: "2.4.3", 
        data: "17/01/2025", 
        listDescricoes: [
            "Correção ao gravar valor ST",
        ]
    },
    { 
        versao: "2.4.4", 
        data: "24/01/2025", 
        listDescricoes: [
            "Correção não considerar o valor de certificação no calcula da margem",
            "Calcular os impostos do valor ST após uso da calculadora",
        ]
    },
    { 
        versao: "2.4.5", 
        data: "24/01/2025", 
        listDescricoes: [
            "Calcular os impostos do valor ST após uso da calculadora",
        ]
    },
    { 
        versao: "2.4.6", 
        data: "24/01/2025", 
        listDescricoes: [
            "Calcular os impostos do valor ST após uso da calculadora",
        ]
    },
    { 
        versao: "2.4.7", 
        data: "27/01/2025", 
        listDescricoes: [
            "Calcular os impostos do valor ST após uso da calculadora",
        ]
    },
    { 
        versao: "2.4.8", 
        data: "29/01/2025", 
        listDescricoes: [
            "Ajuste para mostrar corretamente o valor st no link do cliente",
            "Tratamento adicional para o ultimo codigo do produto parametrizado",
        ]
    },
    { 
        versao: "2.5.0", 
        data: "03/02/2025", 
        listDescricoes: [
            "Correção no valor st quando há mais de 1 qtde",
            "Correção na importação quando só há sub-estrutura",
        ]
    },
    { 
        versao: "2.5.1", 
        data: "03/02/2025", 
        listDescricoes: [
            "Colocar a trava de código produto duplicado somente para os fechados",
        ]
    },
    { 
        versao: "2.5.3", 
        data: "12/02/2025", 
        listDescricoes: [
            "Liberação de usuário LATAM",
            "Ajustes no uso da calculadora",
            "Correções de calculo de desconto no carrinho",
            "Ajuste na lentidão do cadastro de produtos",
            "Correções na flag de revisões anteriores",
        ]
    },
    { 
        versao: "2.5.4", 
        data: "12/02/2025", 
        listDescricoes: [
            "Ajuste condição de pagamento",
        ]
    },
    { 
        versao: "2.5.5", 
        data: "12/02/2025", 
        listDescricoes: [
            "Ajuste no cadastro de descontos",
        ]
    },
    { 
        versao: "2.5.6", 
        data: "22/02/2025", 
        listDescricoes: [
            "Ajuste na calculadora do carrinho",
        ]
    },
    { 
        versao: "2.5.7", 
        data: "24/02/2025", 
        listDescricoes: [
            "Ajuste na importação",
        ]
    },
    { 
        versao: "2.5.8", 
        data: "25/02/2025", 
        listDescricoes: [
            "Ajuste no cadastro de produtos",
            "Tratativa na montagem do código do produto",
        ]
    },
    { 
        versao: "2.6.0", 
        data: "25/02/2025", 
        listDescricoes: [
            "Fluxo de cadastro de produtos",
            "Funcionalidades Latam",
        ]
    },
    { 
        versao: "2.6.1", 
        data: "27/02/2025", 
        listDescricoes: [
            "Ajuste no calculo",
        ]
    },
    { 
        versao: "2.6.2", 
        data: "27/02/2025", 
        listDescricoes: [
            "Ajuste no calculo",
        ]
    },
    { 
        versao: "2.6.3", 
        data: "07/03/2025", 
        listDescricoes: [
            "Adicionado configuração do desconto para o LATAM",
            "Calculo do preço para o LATAM",
            "Ajuste na busca do produto na edição da cotação",
        ]
    },
    { 
        versao: "2.6.5", 
        data: "12/03/2025", 
        listDescricoes: [
            "Ajuste na listagem da cotação para o LATAM",
            "Acrescentado 3 casas decimais para o valor dolar do cambio",
            "Adicionado na criação do pedido o campo ICOTERMO",
            "Adicionado flag latam na integração do pedido para o Totvs",
        ]
    },
    { 
        versao: "2.6.6", 
        data: "17/03/2025", 
        listDescricoes: [
            "Ajuste ao carregar os parametros para o LATAM",
        ]
    },
    { 
        versao: "2.6.8", 
        data: "24/03/2025", 
        listDescricoes: [
            "Correção no calculo do preço LATAM",
        ]
    },
    { 
        versao: "2.6.9", 
        data: "07/04/2025", 
        listDescricoes: [
            "Retirado informação de dias corridos quando pedido",
        ]
    },
    { 
        versao: "2.7.0", 
        data: "17/04/2025", 
        listDescricoes: [
            "Adicionado campo CELULA no cadastro de produto e integração com o totvs",
        ]
    },
    { 
        versao: "2.7.1", 
        data: "13/05/2025", 
        listDescricoes: [
            "Ajuste na listagem de distribuidor",
        ]
    },
    { 
        versao: "2.7.2", 
        data: "13/05/2025", 
        listDescricoes: [
            "Ajuste na consulta do produto",
        ]
    },
    { 
        versao: "2.7.3", 
        data: "28/05/2025", 
        listDescricoes: [
            "Ajuste na listagem de distribuidores no cadastro de usuários",
        ]
    },
    { 
        versao: "2.7.4", 
        data: "30/05/2025", 
        listDescricoes: [
            "Ajustes LATAM",
        ]
    },
    { 
        versao: "2.7.5", 
        data: "09/06/2025", 
        listDescricoes: [
            "Correção na regra de itens com certificação EX",
        ]
    },
    { 
        versao: "2.7.6", 
        data: "12/06/2025", 
        listDescricoes: [
            "Ajustes LATAM",
        ]
    },
    { 
        versao: "2.7.7", 
        data: "18/06/2025", 
        listDescricoes: [
            "Ajuste no prazo de entrega na impressão da cotação",
        ]
    },
    { 
        versao: "2.7.8", 
        data: "23/06/2025", 
        listDescricoes: [
            "Ajuste ao montar código do produto quando colado",
        ]
    },
    { 
        versao: "2.7.9", 
        data: "07/07/2025", 
        listDescricoes: [
            "Correção na visualização do valor no dashboard",
            "Correção na visualização do prazo de entrega no PDF",
            "Gravação do contexto na cotação",
            "Correção para não habilitar abatimento de saldo de campanha",
        ]
    },
    { 
        versao: "2.8.0", 
        data: "10/07/2025", 
        listDescricoes: [
            "Correção no calculo da margem efetiva quando usar a calculadora",
        ]
    },
    { 
        versao: "2.8.1", 
        data: "16/07/2025", 
        listDescricoes: [
            "Ajuste para mostrar a moeda correta na cotação",
            "Para o LATAM, não usar certificação EX",
        ]
    },
    { 
        versao: "2.8.2", 
        data: "17/07/2025", 
        listDescricoes: [
            "Considerar distribuidor LATAM no contexto",
            "Ajuste na chave da consulta de cliente/distribuidor",
        ]
    },
    { 
        versao: "2.8.3", 
        data: "30/07/2025", 
        listDescricoes: [
            "Ajustar moeda conforme contexto na edição da cotação",
        ]
    },
    { 
        versao: "2.8.4", 
        data: "05/08/2025", 
        listDescricoes: [
            "Ajuste prazo de entrega para pedidos turbo",
        ]
    },
    { 
        versao: "2.8.5", 
        data: "19/09/2025", 
        listDescricoes: [
            "Ajuste no calculo da margem quando há certificação EX",
        ]
    },
    { 
        versao: "2.8.6", 
        data: "09/04/2026", 
        listDescricoes: [
            "Lead time médio",
            "Faturamento Parcial e Antecipado",
            "Campo Inglês no cadastro de produto",
            "Melhorias na tela de desconto",
        ]
    },
    { 
        versao: "2.8.7", 
        data: "30/04/2026", 
        listDescricoes: [
            "Campanha Sazonal",
            "Adicionar usuário aprovador para integração no Totvs",
        ]
    },
    { 
        versao: "2.8.8", 
        data: "30/04/2026", 
        listDescricoes: [
            "Correção na validação da familia EX",
            "Ao gerar cotações de marcas diferentes não estavam gravando o contato em ambas cotações",
            "Ao editar cotações não estava aplicando a campanha sazonal",
            "Mostrar nome da campanha sazonal no carrinho e na edição da cotação",
        ]
    },
    { 
        versao: "2.9.0", 
        data: "15/06/2026", 
        listDescricoes: [
            "Acrescentado data da ultima alteração no cadastro de produto",
        ]
    },
    { 
        versao: "2.9.1", 
        data: "23/06/2026", 
        listDescricoes: [
            "Adicionado subestrutura ao solicitar cadastro",
        ]
    },
    { 
        versao: "2.9.2", 
        data: "11/09/2026", 
        listDescricoes: [
            "Ajuste para mostrar o prazo de entrega",
        ]
    },
    { 
        versao: "2.9.3", 
        data: "07/10/2026", 
        listDescricoes: [
            "Reforma tributária",
        ]
    },
    { 
        versao: "2.9.4", 
        data: "16/10/2026", 
        listDescricoes: [
            "Correção na edição da calculadora para LATAM",
        ]
    },
    { 
        versao: "2.9.5", 
        data: "28/10/2026", 
        listDescricoes: [
            "Alteração no fluxo de criação do pedido",
        ]
    }
]